import { DeliveryIssueTypeDomestic } from '../../../../enums';

export interface IDeliverySubtypeDom {
    issueType: DeliveryIssueTypeDomestic;
    deliveryDocumentationIncorrectAddress?: boolean;
    incorrectDeliveryAddress?: string;
}
